"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deSerialiseFunction = (serializedFunction) => {
    return new Function(`return ${serializedFunction}`)();
};
const reFunc = new RegExp("^\\(row,[ ]?col\\).*");
/**
 * Check whether the given string is a plain string or a serialized function
 * @param value
 *
 */
exports.isSerializedFunction = (value) => reFunc.test(`${value}`);
exports.convertSerializedIntoJS = (serialized, row, col) => {
    if (typeof serialized === "string") {
        const _serialized = serialized.trim();
        const des = exports.isSerializedFunction(_serialized)
            ? exports.deSerialiseFunction(_serialized)(row, col)
            : _serialized;
        return des;
    }
    return serialized;
};
//# sourceMappingURL=util.js.map